export default function Contact() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-2">
            联系我们
          </h2>
          <p className="text-sm text-foreground-600 text-center mb-8 md:mb-10">
            合作投稿、问题反馈、意见建议，欢迎通过以下方式与我们取得联系
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
            <div className="p-6 rounded-lg bg-background-50 border border-background-200 text-center">
              <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-primary-100 flex items-center justify-center">
                <span className="w-6 h-6 flex items-center justify-center text-primary-600">
                  <i className="ri-mail-line text-xl"></i>
                </span>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-2">
                商务合作
              </h3>
              <p className="text-xs text-foreground-600 leading-relaxed">
                品牌推广、广告投放等商务合作事宜
              </p>
              <p className="text-xs text-primary-600 font-medium mt-2">
                business@nvshenmanhua.com
              </p>
            </div>

            <div className="p-6 rounded-lg bg-background-50 border border-background-200 text-center">
              <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-accent-100 flex items-center justify-center">
                <span className="w-6 h-6 flex items-center justify-center text-accent-600">
                  <i className="ri-edit-line text-xl"></i>
                </span>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-2">
                作者投稿
              </h3>
              <p className="text-xs text-foreground-600 leading-relaxed">
                漫画作者作品投稿与入驻申请
              </p>
              <p className="text-xs text-accent-600 font-medium mt-2">
                submit@nvshenmanhua.com
              </p>
            </div>

            <div className="p-6 rounded-lg bg-background-50 border border-background-200 text-center">
              <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-secondary-100 flex items-center justify-center">
                <span className="w-6 h-6 flex items-center justify-center text-secondary-600">
                  <i className="ri-customer-service-line text-xl"></i>
                </span>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-2">
                用户反馈
              </h3>
              <p className="text-xs text-foreground-600 leading-relaxed">
                使用问题、意见反馈与功能建议
              </p>
              <p className="text-xs text-secondary-600 font-medium mt-2">
                feedback@nvshenmanhua.com
              </p>
            </div>
          </div>

          <div className="mt-8 p-6 rounded-lg bg-background-100 border border-background-200 text-center">
            <p className="text-sm text-foreground-700">
              工作时间：周一至周五 9:00 - 18:00 · 我们会在24小时内回复您的邮件
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}